import { CustomTemplatedMessageVariables } from 'generated-graphql/types';
import { CampaignType } from 'services/campaign/types';

export const getDefaultSubjectLine = ({
  campaignType
}: {
  campaignType: CampaignType;
}) => {
  switch (campaignType) {
    case CampaignType.APPLICANT_OUTREACH:
      return `Your application to the {{${CustomTemplatedMessageVariables.JobTitle}}} role`;
    case CampaignType.NEW_CANDIDATE_OUTREACH:
      return `We're hiring for a {{${CustomTemplatedMessageVariables.JobTitle}}} and would love to hear from you`;
    case CampaignType.ENGAGEMENT_OUTREACH:
      return 'Information request';
    case CampaignType.ATS_JOB_APPLICATION_URL_OUTREACH:
      return `{{${CustomTemplatedMessageVariables.CandidateFirstName}}} - {{${CustomTemplatedMessageVariables.OrganizationName}}} opportunity - apply now`;
    case CampaignType.REQUEST_CV_OUTREACH:
      return `Job opportunity - {{${CustomTemplatedMessageVariables.JobTitle}}} at {{${CustomTemplatedMessageVariables.EmployerName}}}`;
    default:
      return '';
  }
};
